module.exports = __webpack_public_path__ + "img/life-science-nutritional.4cec18d6.png";